import { createContext } from 'react';

export type AdminAgentScope = 'portfolio' | 'organization';

export type AdminAgentOpenOptions = {
  /** When false, update scope without opening the drawer (route sync). Default true. */
  open?: boolean;
};

export type AdminAgentActionsContextValue = {
  eligible: boolean;
  /** Open the drawer without changing portfolio/organization scope. */
  openDrawer: () => void;
  openPortfolio: (options?: AdminAgentOpenOptions) => void;
  openOrganization: (clientId: string, clientName: string, options?: AdminAgentOpenOptions) => void;
};

export type AdminAgentPanelContextValue = {
  open: boolean;
  setOpen: (open: boolean) => void;
  scope: AdminAgentScope;
  organizationId: string | undefined;
  organizationName: string | undefined;
};

// Stable module: createContext runs once. Keeping this out of the provider/hooks files
// lets Vite HMR remount those files without replacing the context identity.
export const ActionsContext = createContext<AdminAgentActionsContextValue | null>(null);
export const PanelContext = createContext<AdminAgentPanelContextValue | null>(null);
